import { render } from "./WatchlistProView.vue?vue&type=template&id=841112e6&scoped=true"
import script from "./WatchlistProView.vue?vue&type=script&lang=js"
export * from "./WatchlistProView.vue?vue&type=script&lang=js"

import "./WatchlistProView.vue?vue&type=style&index=0&id=841112e6&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-841112e6"]])

export default __exports__